var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"texts-wrapper"},on:{"click":function($event){return _vm.reloadRandom()}}},_vm._l((_vm.randoms),function(text){return _c('span',{staticClass:"text"},[_vm._v(_vm._s(text))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }